<template lang="pug">
.container.column
  el-card.card#os-main
    h4.card-title Relatórios de Ordens de Serviço
    el-card.card.mb
      Filtro(:isFiltroProcesso="false" @search="pesquisarOS")
    div.radio-buttons
      el-radio-group(v-model="isTabelaOS")
        el-radio-button(:label="false") Gráfico
        el-radio-button(:label="true") Tabela
    el-card.card(v-if="isTabelaOS" key="tabela-os")
      TabelaOS(:dados="dadosOS")
      el-row.page-margin
        app-paginacao(
          :total="totalEventosOS",
          :pagina="filtroOs.pagina + 1",
          :tamanhoPagina="filtroOs.tamanhoPagina",
          @changePage="changePageOs"
        )
    div#graphs-card.graphs-card(v-if="!isTabelaOS && dadosOS.length > 0" key="grafico-os")
      el-row.descricao
        div.pendentes
          div.cinza
          | Processos pendentes
        div.tramitados
          div.verde
          | Processos tramitados
      div.grafico-container
        div(v-for="(os, idx) in dadosOS" :key="os.idOS" :class="[`graph_${idx + 1}`]").graphs-card-body
          Grafico(:dados="os")
      el-row.page-margin
        app-paginacao(
          :total="totalEventosOS",
          :pagina="filtroOs.pagina + 1",
          :tamanhoPagina="filtroOs.tamanhoPagina",
          @changePage="changePageOs"
        )
    div.graphs-card(v-if="!isTabelaOS && dadosOS.length === 0" key="empty-data")
      div.no-data
        | Sem dados
    el-row.button-row(v-if="dadosOS.length > 0")
      el-button(
        @click="exportarOS(isTabelaOS)"
      ).primary
        i.fal.fa-file-csv
        span &nbsp Exportar CSV
  el-card.card#processo-main
    h4.card-title Processos
    el-card.card.mb
      Filtro(:isFiltroProcesso="true" @search="pesquisarProcesso")
    el-card.card
      TabelaProcesso(:dados="dadosProcesso")
      el-row.page-margin
        app-paginacao(
          :total="totalEventosTabelaProcesso",
          :pagina="filtroProcesso.pagina + 1",
          :tamanhoPagina="15",
          @changePage="changePageProcesso"
        )
    el-row.button-row(v-if="dadosProcesso.length > 0")
      el-button(
        type="primary",
        @click="exportarProcesso()"
      ).primary
        i.fal.fa-file-csv
        span &nbsp Exportar
</template>

<script>
import Grafico from '../components/os/Grafico'
import Filtro from '../components/os/Filtro'
import TabelaOS from '../components/os/TabelaOS'
import TabelaProcesso from '../components/os/TabelaProcesso'
import { mapActions } from 'vuex'
import moment from 'moment'
import AppPaginacao from '@/components/AppPaginacao'
import domtoimage from 'dom-to-image'
import format from '@/utils/utils'

const HOJE = new Date().getTime()
const UM_ANO = new Date().getTime() - 3600 * 1000 * 24 * 365

export default {

  components: {
    Filtro,
    TabelaOS,
    Grafico,
    TabelaProcesso,
    AppPaginacao
  },

  data () {
    return {
      dadosOS: [],
      isTabelaOS: false,
      totalEventosOS: 0,
      dadosProcesso: [],
      totalEventosTabelaProcesso: 0,
      filtroOs: {
        ordensServico: [],
        tecnicosCampo: [],
        periodoInsercao: [UM_ANO, HOJE],
        dataInicio: moment(UM_ANO).format('DD/MM/YYYY'),
        dataFim: moment(HOJE).format('DD/MM/YYYY'),
        tiposProcesso: [],
        municipios: [],
        pagina: 0,
        tamanhoPagina: 20
      },

      filtroProcesso: {
        numeroProcesso: '',
        listIdOrdemServico: [],
        listIdMunicipio: [],
        listCodigoSituacao: [],
        listIdTecnicosCampo: [],
        listIdTipoCadastro: [],
        listCpfInteressado: [],
        periodoInsercao: [UM_ANO, HOJE],
        periodoInicial: moment(UM_ANO).format('DD/MM/YYYY'),
        periodoFinal: moment(HOJE).format('DD/MM/YYYY'),
        pagina: 0
      }

    }
  },

  async created () {
    this.getOSData(this.filtroOs)
    this.getProcessoData(this.filtroProcesso)
  },

  methods: {
    ...mapActions({
      getDadosOs: 'relatoriosOs/getDadosOs',
      getDadosProcesso: 'relatoriosOs/getDadosProcesso',
      exportaCSVProcesso: 'relatoriosOs/exportaCSVProcesso',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader',
      exportaCSVOS: 'relatoriosOs/exportaCSVOS'
    }),

    getOSData (filtro) {
      this.getDadosOs(filtro).then((res) => {
        this.dadosOS = res.content
        this.totalEventosOS = res.totalElements
      })
    },

    getProcessoData (filtro) {
      this.getDadosProcesso(filtro).then((res) => {
        this.dadosProcesso = res.processos
        this.totalEventosTabelaProcesso = res.total
      })
    },

    pesquisarOS (filtro) {
      this.filtroOs = filtro
      this.filtroOs.pagina = 0
      this.getOSData(this.filtroOs)
    },

    changePageOs (newPage) {
      this.filtroOs.pagina = newPage - 1
      this.getOSData(this.filtroOs)
    },

    pesquisarProcesso (filtro) {
      this.filtroProcesso = filtro
      this.filtroProcesso.pagina = 0
      this.getProcessoData(this.filtroProcesso)
    },

    changePageProcesso (newPage) {
      this.filtroProcesso.pagina = newPage - 1
      this.getProcessoData(this.filtroProcesso)
    },

    exportarOS (isTabela) {
      if (!isTabela) {
        this.setLoader()
        const that = this
        let exportDate = this.formatDate(new Date(), 'DD/MM/YYYY_HH:mm:ss')
        domtoimage.toBlob(document.getElementById('graphs-card'))
          .then(function (blob) {
            window.saveAs(blob, 'Grafico_OS_' + exportDate + '.png')
            that.resetLoader()
          })
      } else {
        this.exportaCSVOS(this.filtroOs)
      }
    },

    exportarProcesso () {
      const filtro = this.filtroProcesso
      this.exportaCSVProcesso(filtro)
    },

    formatDate (data, formato) {
      return format.formatDate(data, formato)
    }

  },

  watch: {
    'isTabelaOS' (val) {
      this.filtroOs.pagina = 0

      if (val === true) {
        this.filtroOs.tamanhoPagina = 15
        this.getOSData(this.filtroOs)
      } else {
        this.filtroOS.tamanhoPagina = 20
        this.getOSData(this.filtroOs)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';
#os-main >>> .el-card, #processo-main >>> .el-card {
  margin-left: 0;
  margin-right: 0;
}

.card-title {
  font-weight: 900;
  font-size: 1.1rem;
}

.mb {
  margin-bottom: 23px;
}

.page-margin {
  margin: 10px auto;
}

.column {
  display: flex;
  flex-direction: column;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  padding: 0 73px;
}

.radio-buttons {
  position: relative;
  display: flex;
  justify-content: center;
  top: 45px;
}

.descricao {
  margin: 23px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 0.95rem;
}

.verde, .cinza {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.verde {
  background-color: $color-primary ;
}

.cinza {
  background-color: $border-color;
}

.pendentes, .tramitados {
  display: flex;
  align-items: center;
}

.pendentes {
  margin-right: 50px;
}

.no-data {
  text-align: center;
  margin: 23px;
  padding: 23px;
  border-bottom: 1px solid $border-color;
  border-top: 1px solid $border-color;
  color: $font-color;
  font-size: 14px;
}

.graphs-card {
  box-shadow:  0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin: 23px 0;
  background-color: white;
}

.grafico-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(auto-fill, 1fr);
  gap: 20px;
}

.graphs-card-body {
  margin: 23px auto;
}

.graph_1, .graph_6, .graph_11, .graph_16 {
  grid-column: 1/1;
}

.graph_2, .graph_7, .graph_12, .graph_17 {
  grid-column: 2/2;
}

.graph_3, .graph_8, .graph_13, .graph_18{
  grid-column: 3/3;
}

.graph_4, .graph_9, .graph_14, .graph_19 {
  grid-column: 4/4;
}

.graph_5, .graph_10, .graph_15, .graph_20 {
  grid-column: 5/5;
}

.graph_1, .graph_2, .graph_3, .graph_4, .graph_5 {
  grid-row: 1/1;
}

.graph_6, .graph_7, .graph_8, .graph_9, .graph_10 {
  grid-row: 2/2;
}

.graph_11, .graph_12, .graph_13, .graph_14, .graph_15 {
  grid-row: 3/3;
}

.graph_16, .graph_17, .graph_18, .graph_19, .graph_20 {
  grid-row: 4/4;
}

@media(max-width: 1390px) {
  .grafico-container {
    grid-template-columns: repeat(4, 1fr);
  }

  .graph_1, .graph_5, .graph_9, .graph_13, .graph_17 {
    grid-column: 1/1;
  }

  .graph_2, .graph_6, .graph_10, .graph_14, .graph_18 {
    grid-column: 2/2;
  }

  .graph_3, .graph_7, .graph_11, .graph_15, .graph_19 {
    grid-column: 3/3;
  }

  .graph_4, .graph_8, .graph_12, .graph_16, .graph_20 {
    grid-column: 4/4;
  }

  .graph_1, .graph_2, .graph_3, .graph_4 {
    grid-row: 1/1;
  }

  .graph_5, .graph_6, .graph_7, .graph_8 {
    grid-row: 2/2;
  }

  .graph_9, .graph_10, .graph_11, .graph_12 {
    grid-row: 3/3;
  }

  .graph_13, .graph_14, .graph_15, .graph_16 {
    grid-row: 4/4;
  }

  .graph_17, .graph_18, .graph_19, .graph_20 {
    grid-row: 5/5;
  }
}

@media (max-width: 780px) {
  .grafico-container {
    display: flex;
    flex-direction: column;
  }

  .button-row {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/os/OS.vue